module.exports = __webpack_public_path__ + "images/icons_v2/get-started-filled-a8e6bf68.svg";